export default class Avatar {
    constructor() {
        this.name = null
        this.size = 0
        this.src = null
    }
}
